import { useState } from "react";

const TabLayout = ({ container = "tab-section", title = "", tabs = [] }) => {
	const [activeTab, setActiveTab] = useState(0);

	return (
		<div className={container} data-tab-section>
			{title && <h2>{title}</h2>}
			<div className="tab-nav">
				{tabs.map((tab, index) => (
					<div key={index} className={` tab-link ${activeTab === index ? "active" : ""}`} data-tab-target={index} onClick={() => setActiveTab(index)}>
						{tab.title}
					</div>
				))}
			</div>
			<div className="tab-cont">
				{tabs.map((tab, index) => (
					<div key={index} className={`tab-item ${activeTab === index ? "active" : ""}`} data-tab={index} style={{ display: activeTab === index ? "block" : "none" }}>
						<h2 className="title3">{tab.title}</h2>
						{tab.content}
					</div>
				))}
			</div>
		</div>
	);
};

export default TabLayout;
